
import { defineComponent } from 'vue';
import PrzItem from '../AbstractItem/Component.vue';
import PrzElementContent from '../Parts/ContentElement/Component.vue';
import { BlockItem } from '@/models/Blocks/Itens/block-item';
import { BlockWhy } from '@/models/Blocks/Itens/block-why';
export default defineComponent({
    components:{
        PrzItem,
        PrzElementContent
    },
    props:{
        item:{
            type: BlockItem,
        }
    },
    computed:{
        why(): BlockWhy|null{
            return this.item instanceof BlockWhy ? <BlockWhy>this.item : null;
        }
    }
});
